import { useMediaQuery } from "@cd2/components/build/es6"

export function useCommonBreakpoints() {
  const [isSmall] = useMediaQuery([{ maxWidth: 850 }])
  return { isSmall }
}
